<template>
    <div class="p-3">
        b2b invoices
    </div>
</template>

<script>
export default {
    name: "B2bInvoice",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
